<template>
  <div class="cart-container">
    <el-row class="cart-box">
      <el-col :span="24">
        <div class="nb">
          <div class="cart-step">
            <ul>
              <li class="cart1"><i></i>购物车</li>
              <li class="cart2"><i></i>确认订单</li>
              <li class="cart3"><i></i>付款</li>
              <li class="cart4"><i></i>支付成功</li>
            </ul>
          </div>
          
          <cart-table 
            :cartInfo="cartInfo"
            @on-sel="onSel"
            @add-prod="addProd"
            @minus-prod="minusProd"
            @edit-prod="editProdcartNum"
            @del-prod="delProd"
            @go-order="gotOrder"
          />

          <div class="account">
            <div class="left"></div>
            <div class="right">
              <div class="r-lside">
                <div class="yunfei">
                  <p class="yixuan">已选商品<span class="orange-bold">{{cartInfo.totalNum}}</span>件</p>
                  <p>总价：<span class="orange-bold big">￥{{cartInfo.totalMount}}</span></p>
                </div>
              </div>
              <div class="r-rside">
                <el-button type="primary" class="btn-jiesuan" @click="gotOrder">去结算</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CartTable from '@/components/plateform/cart/CartTable.vue'
import { listStoreCart, updateStoreCart, deleteStoreCart } from '@/api/plateform/cart/cartApi'

export default {
  name: 'CartView',
  components: {
    CartTable
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 100,
      cartInfo: {
        prods: [],
        total: 0,
        records: 1,
        moreCondition: false,
        totalMount: 0.00,
        totalNum: 0,
        conditions: {
          storeId: '',
          name: '',
          address: '',
          tel: '',
          createUserId: '',
          state: ''
        }
      }
    }
  },
  created() {
    this._listOrderCarts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    _caculTotalMount() {
      let j = 0, k = 0
      this.cartInfo.prods.forEach(item => {
        if (!isNaN(item.cartNum) && !isNaN(item.price)) {
          j += parseFloat(item.cartNum) * parseFloat(item.price).toFixed(2)
          k += parseFloat(item.cartNum)
        } else {
          this.cartInfo.totalMount = "请输入正确的数字"
          this.cartInfo.totalNum = "请输入正确的数字"
          throw Error()
        }
      })
      this.cartInfo.totalMount = j.toFixed(2)
      this.cartInfo.totalNum = k
    },
    editProdcartNum(prod, newNum) {
      const reg = /^[1-9]\d*$|^0$/
      if(!reg.test(newNum)){
        this.$message("请输入有效数字")
        return
      }
      if(newNum == 0){
        this.$message("请输入大于零的数字")
        return
      }
      prod.cartNum = newNum
      this._updateCart(prod)
    },
    addProd(prod) {
      prod.cartNum = parseInt(prod.cartNum) + 1
      this._updateCart(prod)
    },
    minusProd(prod) {
      if(prod.cartNum <=1){
        this.$message("不能在减少了，最小数量为1")
        return
      }
      prod.cartNum = prod.cartNum - 1
      this._updateCart(prod)
    },
    delProd(prod) {
      deleteStoreCart(prod).then(res => {
        if (res.code === 0) {
          this._listOrderCarts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    _listOrderCarts(page, rows) {
      this.cartInfo.conditions.page = page
      this.cartInfo.conditions.row = rows
      
      listStoreCart(this.cartInfo.conditions).then(res => {
        this.cartInfo.total = res.total
        this.cartInfo.records = res.records
        this.cartInfo.prods = res.data
        this._caculTotalMount()
      }).catch(err => {
        console.error('请求失败:', err)
      })
    },
    _updateCart(prod) {
      updateStoreCart(prod).then(res => {
        if (res.code === 0) {
          this._listOrderCarts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    gotOrder() {
      let payGoods = []
      this.cartInfo.prods.forEach(item => {
        if (item.checked) {
          payGoods.push(item)
        }
      })
      if (payGoods.length < 1) {
        this.$message("请先选择商品")
        return
      }
      let shopId = payGoods[0].shopId
      let oneShopGoods = true
      payGoods.forEach(g => {
        if (shopId != g.shopId) {
          oneShopGoods = false
        }
      })
      if (!oneShopGoods) {
        this.$message("必须同店铺一起支付")
        return
      }
      
      let productId = payGoods.map(g => g.productId).join(',')
      let valueId = payGoods.map(g => g.valueId).join(',')
      let goodsNum = payGoods.map(g => g.cartNum).join(',')
      let cartId = payGoods.map(g => g.cartId).join(',')

      if(payGoods.length === 0){
        this.$message("请先选择商品")
        return
      }
      
      this.$router.push(`/pageLR.html#/pages/plateform/order?productId=${productId}&shopId=${shopId}&valueId=${valueId}&goodsNum=${goodsNum}&cartId=${cartId}`)
    },
    onSel(index, prod) {
      console.log(prod)
      this.cartInfo.prods[index].checked = !this.cartInfo.prods[index].checked
      let totalNum = 0, totalMount = 0.0
      this.cartInfo.prods.forEach(item => {
        if(item.checked) {
          totalMount += parseFloat(item.cartNum) * parseFloat(item.price).toFixed(2)
          totalNum += parseFloat(item.cartNum)
        }
      })
      this.cartInfo.totalMount = totalMount.toFixed(2)
      this.cartInfo.totalNum = totalNum
    }
  }
}
</script>

<style scoped>
.cart-container {
  padding: 20px;
}
.cart-box {
  background: #fff;
  padding: 20px;
}
.cart-step ul {
  display: flex;
  justify-content: space-around;
  padding: 0;
  margin: 0 0 20px 0;
  list-style: none;
}
.cart-step li {
  position: relative;
  padding: 0 0 0 30px;
  color: #999;
}
.cart-step li i {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: #eee;
  border-radius: 50%;
}
.cart-step li.cart1 {
  color: #409EFF;
}
.cart-step li.cart1 i {
  background: #409EFF;
}
.account {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding: 20px;
  background: #f5f5f5;
}
.r-lside {
  display: flex;
  align-items: center;
}
.yunfei p {
  margin: 0 10px 0 0;
}
.orange-bold {
  color: #ff6700;
  font-weight: bold;
}
.big {
  font-size: 18px;
}
.btn-jiesuan {
  background: #ff6700;
  border-color: #ff6700;
}
</style>